var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ClickAwayListener, Fade, Paper, Popper, Typography } from '@material-ui/core';
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons';
import { useRef, useState } from 'react';
import { Category } from './Category';
export function CategorySelector(_a) {
    var categories = _a.categories, onSelect = _a.onSelect;
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var _c = useState(null), current = _c[0], setCurrent = _c[1];
    var arrowRef = useRef(null);
    var handleClick = function (event) {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    var handleClickAway = function () {
        setAnchorEl(null);
    };
    var handleSelect = function (c) {
        setAnchorEl(null);
        setCurrent(c);
        onSelect(c);
    };
    var open = Boolean(anchorEl);
    var id = open ? 'category-selector' : undefined;
    return (_jsxs("div", { className: "category-selector", children: [_jsx(Button, { className: "category-selector__button", variant: "outlined", "aria-describedby": id, onClick: handleClick, startIcon: _jsx(ExpandMoreIcon, {}), children: (current && current.title) || 'カテゴリで絞る' }), _jsx(Popper, { id: id, open: open, anchorEl: anchorEl, transition: true, placement: "bottom-start", disablePortal: false, modifiers: {
                    flip: {
                        enabled: true,
                    },
                    preventOverflow: {
                        enabled: true,
                        boundariesElement: 'scrollParent',
                    },
                    arrow: {
                        enabled: false,
                        element: arrowRef,
                    },
                }, className: "category-selector__popper", children: function (_a) {
                    var TransitionProps = _a.TransitionProps;
                    return (_jsx(ClickAwayListener, { onClickAway: handleClickAway, children: _jsx(Fade, __assign({}, TransitionProps, { timeout: 350, children: _jsxs("div", { className: "category-selector__wrapper", children: [_jsx("div", { className: "arrow", ref: arrowRef }), _jsxs(Paper, { className: "category-selector__paper", square: true, children: [_jsx(Typography, { variant: "h2", className: "category-selector__title", children: "\u30AB\u30C6\u30B4\u30EA\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044" }), _jsx(Category, { categories: categories, onSelect: handleSelect })] })] }) })) }));
                } })] }));
}
//# sourceMappingURL=CategorySelector.js.map